module.exports = __webpack_public_path__ + "static/media/add_image.4932d71e.svg";